import { TableHeader } from '@/components/ui/table';

export function AgeInYearsHeader() {
  return (
    <TableHeader narrow className="text-left align-bottom">
      Age in Years
    </TableHeader>
  );
}
